/*
 * File: CalendarCard.tsx
 * Project: a-a
 * File Created: Wednesday, 27th August 2025 4:37:59 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 11th September 2025 10:21:20 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../../../theme/Color';
import CustomOverlapImg from '../../../../shared/CustomOverlapImg/CustomOverlapImg';
import dayjs from 'dayjs';
import { events } from '@aws-amplify/api-graphql';

const CalendarCard = ({
  height,
  startTime,
  endTime,
  title,
  link,
  color,
  leftPos,
  invitees,
}: {
  height: number;
  startTime: dayjs.Dayjs;
  endTime: dayjs.Dayjs;
  title: string;
  link: string;
  color: string;
  leftPos: any;
  invitees?: any[];
}) => {
  console.log(height);
  return (
    <Box
      sx={{
        backgroundColor: color || zeplinColor.CalendarCard1,
        ...(leftPos > 0 && { border: `1.5px solid ${zeplinColor.Neutral1}` }),
        borderRadius: '14px',
        padding: '12px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        // flexWrap: 'wrap',
        gap: '12px',
        alignItems: 'flex-start',
        height: height,
        overflowY: 'scroll',
        overflowX: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <Typography variant='responsiveBody3'>{title}</Typography>
          <Typography variant='responsiveLabel1'>{`${dayjs(startTime).format('hh:mm a')} - ${dayjs(
            endTime,
          ).format('hh:mm a')}`}</Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: zeplinColor.Neutral1,
            borderRadius: '8px',
            padding: '8px',
            gap: '6px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <img src={'/assets/calendar-video.svg'} style={{ width: '14px', height: '8px' }} />
          <a
            href={link}
            target='_blank'
            rel='noopener noreferrer'
            style={{ textDecoration: 'none' }}
          >
            {' '}
            <Typography
              sx={{
                maxWidth: '100px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
              variant='responsiveLabel1'
            >
              {link}
            </Typography>
          </a>
        </Box>
      </Box>
      <CustomOverlapImg
        images={invitees?.map((val: any) => val.profileImage) || []}
        name={invitees?.map((val: any) => val.name) || []}
      />
    </Box>
  );
};

export default CalendarCard;
